export default __webpack_public_path__ + "static/media/ppt.ae913150.svg";